var render, staticRenderFns
var script = {}
import style0 from "./Notification.vue?vue&type=style&index=0&id=8525ba36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8525ba36",
  null
  
)

export default component.exports